import { forwardRef, ReactNode } from 'react'
import Styles from '../AddReviewers/AddReviewers.module.scss'
import { Field } from '../AddReviewers/Field'
import { RecipientsSelector, Props as RecipientsSelectorProps } from '../RecipientsSelector/RecipientsSelector'
import cx from 'classnames'

export interface RecipientSelectorFieldProps
  extends Pick<RecipientsSelectorProps, 'onChange' | 'recipients' | 'includeGroups' | 'disabled'> {
  label?: string
  id: string
  placeholder?: string
  labelClassNames?: string
  inputClassNames?: string
  recipientsClassNames?: string
  onRecipientActionClick?: () => void
  reviewerRolesDropdown?: ReactNode
}

export const RecipientSelectorField = forwardRef<HTMLDivElement, RecipientSelectorFieldProps>(
  (
    { id, label, labelClassNames, inputClassNames, placeholder = 'Add people or external emails', ...props },
    fRef,
  ) => {
    return (
      <>
        {label && (
          <label htmlFor={id} className={cx(Styles.fieldLabel, labelClassNames)}>
            {label}
          </label>
        )}
        <Field className={cx(Styles.selectorField, inputClassNames)}>
          <RecipientsSelector id={id} ref={fRef} placeholder={placeholder} {...props} />
        </Field>
      </>
    )
  },
)
